import React from 'react';

import DOMPurify from 'isomorphic-dompurify';
import classnames from 'classnames';
import { CardContent } from '@andes/card';

import { withComponentHandler } from '../../hocs/with-component-handler';
import { CollapsibleCardContentPropTypes } from './propTypes';
import { UI_SEARCH_COLLAPSIBLE_CARD_NAMESPACE as namespace } from '../../constants';

/**
 * @typedef {Object} CollapsibleCardContentProps
 * @property {string} content - The HTML content to be displayed in the card
 * @property {boolean} isExpanded - Whether the card is expanded or not
 */

/**
 * CollapsibleCardContent component renders the content section of a collapsible card.
 * It displays HTML content within a CardContent component and manages its visibility based on the expanded state.
 *
 * @param {CollapsibleCardContentProps} props - The props for the component
 * @returns {JSX.Element} A CardContent element containing the HTML content
 */
const CollapsibleCardContent = ({ content, isExpanded }) => (
  <CardContent className={classnames(`${namespace}__content`, { [`${namespace}__content--is-expanded`]: isExpanded })}>
    <div
      className={classnames(`${namespace}__content-text`)}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: content ? DOMPurify.sanitize(content) : '' }}
    />
  </CardContent>
);

CollapsibleCardContent.propTypes = {
  ...CollapsibleCardContentPropTypes,
};

export default withComponentHandler(CollapsibleCardContent, { componentName: 'CollapsibleCardContent' });
